import React from 'react';
import { Box, Text, Image, Anchor } from 'grommet';
import NotFound from '../../assets/404.png'
import { useNavigate } from "react-router-dom"
import { useWarnVersion } from '../../utils/warnVersion'
import { InitInfo } from './Init'

const Error = ({ errno, scope = "", stackerror = {} }) => {

    const history = useNavigate()
    const checkVersion = useWarnVersion()

    if (!errno) {
        errno = "400"
    }

    const text = errno === '500' ? "There was a crash in the application. We have logged the stacktrace and will investigate it, you may also report it to the slack channel" : "If you believe this to be a bug please report it to slack channel"

    return (
        <Box
            fill
            direction="column"
            justify="start"
            align="start"
            alignContent="start"
            pad="medium"
            background="light-1"
            gap="medium"
        >
            <Box gap="medium">
                <Text weight="bold" size="large" color="ttdown">Error {errno}</Text>
                {checkVersion.warnVersion &&
                    <Text size="medium">{"You are using an older version of Control. Reload page to use latest release " + checkVersion.versionNumber + " and try again."} </Text>
                }

                {errno === "403" &&
                    <Text size="medium">Scope {scope} required. Check your scopes <Anchor onClick={() => history("/user")}>here</Anchor></Text>
                }
                <Text size="medium">{text} <Anchor href="slack://channel?id=C05N2LXSBJR&team=T04UP3SC3" label="#pe-help" /></Text>

                {stackerror.errorJson &&
                    <Box pad="small" background="black" overflow={{ horizontal: 'hidden', vertical: 'auto' }}>
                        <Text size="small">Error Message</Text>
                        <Text color="accent-1" size="small" key={JSON.parse(stackerror.errorJson)['message']}>{JSON.parse(stackerror.errorJson)['message']}</Text>
                    </Box>
                }

                {stackerror.errorJsonMsg &&
                    <Box pad="small" background="black" overflow={{ horizontal: 'hidden', vertical: 'auto' }}>
                        <Text size="small">StackTrace</Text>
                        <Text color="accent-1" size="small" key={stackerror.errorJsonMsg}>{stackerror.errorJsonMsg}</Text>
                    </Box>
                }

                <InitInfo />

            </Box>
            <Box width="30%" height="60%">
                <Image
                    fit="contain"
                    src={NotFound}
                />
            </Box>

        </Box>

    )

}

export default Error
